<template>
  <div class="myLight_wrap chinese_container">
    <myHeader />
    <!-- 首页广告模块 -->
    <div class="lighting_banner">
      <div class="lighting_banner_img">
        <img
          src="https://download.hecoos.com/enlightv/2025-17/8298062e074abc9f671d63489b88be82.jpg"
          alt=""
          :style="{ clip: 'rect(0, ' + leftClipWidth + 'px, auto, 0)' }"
        />
        <img
          src="https://download.hecoos.com/enlightv/2025-17/7315d1ddc0075ebea4e3079ab2191629.jpg"
          alt=""
          :style="{ clip: 'rect(0, auto, auto, ' + leftClipWidth + 'px)' }"
        />
      </div>
      <div
        class="twentytwenty-handle"
        :style="{ left: leftClipWidth + 'px' }"
        @mousedown="startDragging"
      ></div>
    </div>

    <!-- 灯光设计模块 -->
    <div class="lighting">
      <canvas id="lighting_canvas"></canvas>
      <div class="lighting_content">
        <p
          style="
            font-size: 72px;
            color: rgb(255, 255, 255);
            font-weight: 700;
            margin-bottom: 80px;
          "
          class="wow fadeInUp ProductTitle"
        >
          灯光设计
        </p>
        <p style="line-height: 50px" class="wow fadeInUp TwoProductTitle">
          无论是灯光效果模拟预演、预编程<br />还是控制真实灯具，hecoos为灯光师提供了高效且富有创意的工作方式。
        </p>
        <router-link
          id="cn_lighting_design_contact_us"
          class="callMe"
          :to="{ name: 'chCaseDemonstration', hash: '#specific-position' }"
          >联系我们</router-link
        >
      </div>
    </div>

    <!-- 先刷重点模块 -->
    <div class="key_points">
      <p
        style="font-size: 72px; font-weight: 700; margin-bottom: 30px"
        class="wow fadeInUp ProductTitle"
      >
        先刷重点
      </p>
      <p
        style="font-size: 24px; color: rgba(255, 255, 255, 0.64)"
        class="wow fadeInUp"
      >
        灯光设计的优势
      </p>
      <img
        v-show="isFirstImage1"
        style="width: 1090px; height: 569px"
        src="https://download.hecoos.com/enlightv/2025-35/eb75ecb23a2a4b44ba9516bb84c9520d.jpg"
        alt=""
      />
      <img
        v-show="isFirstImage2"
        style="width: 1090px; height: 569px"
        src="https://download.hecoos.com/enlightv/2025-35/e024d97b129ce0214f19647e1f7dd820.jpg"
        alt=""
      />
      <img
        v-show="isFirstImage3"
        style="width: 1090px; height: 569px"
        src="https://download.hecoos.com/enlightv/2025-35/39622fe1143bbb20cd3f46fd67e5e308.jpg"
        alt=""
      />
      <div class="button_container">
        <div class="button_list" ref="button_list">
          <button
            :class="{ btn: true, active: isBtn1Active }"
            @click="switchContent(1)"
          >
            灯光预演与预编程
          </button>
          <button
            :class="{ btn: true, active: isBtn2Active }"
            @click="switchContent(2)"
          >
            实时动态调整
          </button>
          <button
            :class="{ btn: true, active: isBtn3Active }"
            @click="switchContent(3)"
          >
            兼容与整合
          </button>
        </div>
        <div
          class="underline"
          :style="{
            width: buttonUnderlineWidth + 'px',
            left: buttonUnderlineLeft + 5 + 'px',
          }"
        ></div>
      </div>
      <div class="text">
        <p v-show="isFirstImage1" class="wow fadeInUp">
          踏入hecoos的世界，添加灯光设备实时预览设计想法，自主编辑灯库文件并配接地址码，基于协议精准控制，一气呵成。
        </p>
        <p v-show="isFirstImage2" class="wow fadeInUp">
          即使是预先编辑好的灯光效果，在面对活动突发变化时也可由灯光师介入干预，快速适应现场需求，确保最佳的效果呈现。
        </p>
        <p v-show="isFirstImage3" class="wow fadeInUp">
          通过对DMX512、Art-Net等控制协议的整合，hecoos对舞台灯具、影视灯具、LED灯条等灯具的控制尽在掌握。
        </p>
      </div>
    </div>

    <!-- 应用场景模块 -->
    <div class="scene">
      <p
        style="font-size: 72px; font-weight: 700; margin-bottom: 30px"
        class="wow fadeInUp ProductTitle"
      >
        应用场景
      </p>
      <p
        style="font-size: 24px; color: rgba(255, 255, 255, 0.64)"
        class="wow fadeInUp"
      >
        灯光设计的实际应用
      </p>
      <myBanner
        :applicationInfo="applicationInfo"
        class="wow fadeInUp"
      ></myBanner>
    </div>

    <!-- 产品模块 -->
    <div class="product">
      <div class="tab">
        <p style="font-size: 36px" class="wow fadeInUp">产品</p>
        <p
          style="font-size: 72px; font-weight: 700; margin-top: 12px"
          class="wow fadeInUp ProductTitle"
        >
          您的灯光工具包
        </p>
        <div class="switch">
          <!-- 为每个 span 绑定点击事件和动态类名 -->
          <div class="switch_list" ref="switch_list">
            <span
              v-for="item in switchList"
              @click="selectTab(item.value)"
              v-text="item.title"
              :key="item.value"
            ></span>
          </div>
          <div
            class="underline"
            :style="{
              width: underlineWidth + 'px',
              left: underlineLeft + 'px',
            }"
          ></div>
        </div>
      </div>
      <!-- 产品内容部分 -->
      <div>
        <div class="projection_content">
          <div class="studio" v-show="showContents[0]">
            <div class="layout">
              <img
                src="https://download.hecoos.com/enlightv/2025-17/a4beea54e9867e8ffcdf6a151c966e1d.png"
                alt=""
                class=""
              />
              <div class="textContent">
                <p style="font-size: 50px; font-weight: 600" class="">
                  hecoos Lighting
                </p>
                <p class="neiR">
                  hecoos
                  Lighting完美适配舞台、影视、建筑照明、商业空间、艺术展览等领域所使用的不同种类灯具，“设计即实现”的理念同样在hecoos
                  Lighting的工作流程中体现，为灯光师提供丰富的创作空间。
                </p>
                <router-link class="call_more" to="/hecoosLighting"
                  >了解更多</router-link
                >
              </div>
            </div>
          </div>
          <div class="studio" v-show="showContents[1]">
            <div class="layout">
              <img
                src="https://download.hecoos.com/enlightv/2025-17/fdb25e23aa3f7ee931dde2f6d7adc9f3.png"
                alt=""
                class=""
              />
              <div class="textContent">
                <p style="font-size: 50px; font-weight: 600" class="">
                  hecoos Studio
                </p>
                <p class="neiR">
                  演你所想，hecoos是一款可预演真实场景的新媒体全域制作软件。
                </p>
                <router-link class="call_more" to="/studio"
                  >了解更多</router-link
                >
              </div>
            </div>
          </div>
          <div class="studio" v-show="showContents[2]">
            <div class="layout">
              <img
                src="https://download.hecoos.com/enlightv/2025-17/b829a8b649c5d90617bc7ba860f34c24.png"
                alt=""
                class=""
              />
              <div class="textContent">
                <p style="font-size: 50px; font-weight: 600" class="">
                  hecoos Server-D
                </p>
                <p class="neiR">
                  依托
                  hecoos工作流程，最大限度管控从展演的灵感到最终落地呈现的各个环节，从而践行“设计即实现”的产品设计理念。
                </p>
                <router-link
                  class="call_more"
                  :to="{ path: '/mediaServer?section=0', hash: '#tab' }"
                  >了解更多</router-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 创意模块 -->
    <Creativity :imgUrl="imgUrl" />
    <myFooter />
    <BackToTop />
  </div>
</template>

<script>
import myHeader from "@/components/pc/myHeader.vue";
import myFooter from "@/components/pc/myFooter.vue";
import Creativity from "@/components/pc/creativity";
import myBanner from "@/components/pc/myBanner";
import BackToTop from "@/components/pc/BackToTop";
import setupCanvas from "@/utils/lighting_canvas.js";
export default {
  data() {
    return {
      isFirstImage1: true,
      isFirstImage2: false,
      isFirstImage3: false,
      // 用于控制按钮的激活状态
      isBtn1Active: true,
      isBtn2Active: false,
      isBtn3Active: false,
      // 新增变量，用于记录当前选中的 tab 索引
      currentTabIndex: 0,
      imgUrl:
        "https://download.hecoos.com/enlightv/2025-17/15ee7aebaec0c2d6bb4d5437a737c89d.png",
      switchList: [
        { value: 0, title: "Lighting" },
        { value: 1, title: "Studio" },
        { value: 2, title: "Server-D" },
      ],
      // 新增数组，用于控制每个产品内容的显示状态
      showContents: [true, false, false, false],
      applicationInfo: [
        {
          imgUrl:
            "https://download.hecoos.com/enlightv/2025-17/b15f1b9fefbc87efb8c1b0e67967b6b1.png",
          title: "媒体立面",
          msg: "像素级规划建筑立面的每一只灯具，以灯为屏，用灯光呈现动画。",
        },
        {
          imgUrl:
            "https://download.hecoos.com/enlightv/2025-17/18a6389f4267011b6e63b29903d0bd00.png",
          title: "艺术装置",
          msg: "多种灯具统一管控，让实现作品创意变得更从容。",
        },
        {
          imgUrl:
            "https://download.hecoos.com/enlightv/2025-17/9c27479528f5da44efd94c11baecfe86.png",
          title: "虚拟制作",
          msg: "打通实时渲染引擎中的虚拟灯光与拍摄现场的真实灯光控制，深度还原场景氛围。",
        },
        {
          imgUrl:
            "https://download.hecoos.com/enlightv/2025-17/1ad3e2e075c074ca3b40146bbfd2ac35.png",
          title: "主题乐园",
          msg: "自动化场景编排，hecoos全天候灯光管理，运维不再难。",
        },
        {
          imgUrl:
            "https://download.hecoos.com/enlightv/2025-17/75ed3bc23bdc692c81c1e959c072493a.png",
          title: "品牌活动",
          msg: "灯光秀预编辑，执行现场仅需微调即可还原设计，大幅减轻现场调试压力。",
        },
      ],

      leftClipWidth: 0,
      isDragging: false,
      containerWidth: 0,

      underlineWidth: 0,
      underlineLeft: 0,

      currentButtonIndex: 1,
      buttonUnderlineWidth: 0,
      buttonUnderlineLeft: 0,
    };
  },
  components: {
    myHeader,
    myFooter,
    Creativity,
    myBanner,
    BackToTop,
  },
  mounted() {
    this.containerWidth = this.$el.querySelector(
      ".lighting_banner_img"
    ).offsetWidth;
    this.leftClipWidth = this.containerWidth / 2;
    // 灯光设计canvas调用
    setupCanvas("lighting_canvas");
    this.$nextTick(() => {
      this.updateUnderlinePosition();
      this.setupSpanResizeObservers();
      this.buttonUpdateUnderlinePosition();
      this.buttonSetupSpanResizeObservers();
      window.addEventListener("resize", this.updateUnderlinePosition);
      window.addEventListener("resize", this.buttonUpdateUnderlinePosition);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateUnderlinePosition);
    window.removeEventListener("resize", this.buttonUpdateUnderlinePosition);
    window.removeEventListener("mousemove", this.handleDrag);
    window.removeEventListener("mouseup", this.stopDragging);
  },
  methods: {
    // 轮播图效果
    startDragging(event) {
      this.isDragging = true;
      this.containerWidth = event.target.parentElement.offsetWidth;
      window.addEventListener("mousemove", this.handleDrag);
      window.addEventListener("mouseup", this.stopDragging);
    },
    handleDrag(event) {
      if (this.isDragging) {
        const newLeft =
          event.clientX -
          event.target.parentElement.getBoundingClientRect().left;
        this.leftClipWidth = Math.min(
          Math.max(0, newLeft),
          this.containerWidth
        );
      }
    },
    stopDragging() {
      this.isDragging = false;
      window.removeEventListener("mousemove", this.handleDrag);
      window.removeEventListener("mouseup", this.stopDragging);
    },

    // 导航切换底部跟随
    updateUnderlinePosition() {
      const switchList = this.$refs.switch_list;
      if (switchList) {
        const span = switchList.querySelectorAll("span")[this.currentTabIndex];
        const switchListRect = switchList.getBoundingClientRect();
        const spanRect = span.getBoundingClientRect();

        // 获取 span 的左右 padding 值
        const computedStyle = window.getComputedStyle(span);
        const paddingLeft = parseFloat(computedStyle.paddingLeft);
        const paddingRight = parseFloat(computedStyle.paddingRight);

        // 计算去除 padding 后的宽度
        this.underlineWidth = spanRect.width - paddingLeft - paddingRight;
        // 计算去除 padding 后的左侧偏移量
        this.underlineLeft = spanRect.left - switchListRect.left + paddingLeft;
      }
    },
    // 文字宽度变化监听
    setupSpanResizeObservers() {
      const spans = this.$refs.switch_list.querySelectorAll("span");
      const resizeCallback = () => {
        this.updateUnderlinePosition();
      };
      spans.forEach((span) => {
        const observer = new ResizeObserver(resizeCallback);
        observer.observe(span);
      });
    },

    // 导航切换底部跟随
    buttonUpdateUnderlinePosition() {
      const switchList = this.$refs.button_list;
      if (switchList) {
        const button =
          switchList.querySelectorAll("button")[this.currentButtonIndex - 1];
        const switchListRect = switchList.getBoundingClientRect();
        const spanRect = button.getBoundingClientRect();

        // 获取 span 的左右 padding 值
        const computedStyle = window.getComputedStyle(button);
        const paddingLeft = parseFloat(computedStyle.paddingLeft);
        const paddingRight = parseFloat(computedStyle.paddingRight);

        // 计算去除 padding 后的宽度
        this.buttonUnderlineWidth = spanRect.width + paddingLeft - paddingRight;

        // 计算去除 padding 后的左侧偏移量
        this.buttonUnderlineLeft =
          spanRect.left - switchListRect.left - paddingLeft + paddingRight;
      }
    },
    // 文字宽度变化监听
    buttonSetupSpanResizeObservers() {
      const buttons = this.$refs.button_list.querySelectorAll("button");
      const resizeCallback = () => {
        this.buttonUpdateUnderlinePosition();
      };
      buttons.forEach((button) => {
        const observer = new ResizeObserver(resizeCallback);
        observer.observe(button);
      });
    },

    // 切换内容和按钮激活状态的方法
    switchContent(type) {
      this.currentButtonIndex = type;
      this.buttonUpdateUnderlinePosition();
      if (type === 1) {
        this.isFirstImage1 = true;
        this.isFirstImage2 = false;
        this.isFirstImage3 = false;
        this.isBtn1Active = true;
        this.isBtn2Active = false;
        this.isBtn3Active = false;
      } else if (type === 2) {
        this.isFirstImage1 = false;
        this.isFirstImage2 = true;
        this.isFirstImage3 = false;
        this.isBtn1Active = false;
        this.isBtn2Active = true;
        this.isBtn3Active = false;
      } else {
        this.isFirstImage1 = false;
        this.isFirstImage2 = false;
        this.isFirstImage3 = true;
        this.isBtn1Active = false;
        this.isBtn2Active = false;
        this.isBtn3Active = true;
      }
    },
    // 新增方法，用于处理 tab 切换
    selectTab(index) {
      this.currentTabIndex = index;
      // 重置所有内容的显示状态为 false
      this.showContents = this.showContents.map(() => false);
      // 将当前选中的内容显示状态设为 true
      this.showContents[index] = true;
      this.updateUnderlinePosition();
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/xty.scss";
@import "@/styles/optimize_adaptation.scss";
</style>
